"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ExerciseIcon = exports.CATEGORY_TO_ICON = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _goals = require("../../constants/goals");

var _colors = _interopRequireDefault(require("../../theme/colors"));

var _Donut = _interopRequireDefault(require("../Graphs/Donut"));

var _BabyExercise = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/BabyExercise"));

var _BallGames = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/BallGames"));

var _Cardio = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Cardio"));

var _Cycling = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Cycling"));

var _Dancing = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Dancing"));

var _Gardening = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Gardening"));

var _Golf = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Golf"));

var _HorseRiding = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/HorseRiding"));

var _HouseWork = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/HouseWork"));

var _Interwalk = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Interwalk"));

var _Other = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Other"));

var _Pilates = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Pilates"));

var _Program = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Program"));

var _Racquet = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Racquet"));

var _Rehabilitation = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Rehabilitation"));

var _Running = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Running"));

var _Swimming = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Swimming"));

var _Walking = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Walking"));

var _Weights = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Weights"));

var _Yoga = _interopRequireDefault(require("../../theme/icons/ExerciseActivities/Yoga"));

var _styled = require("./styled");

var _CATEGORY_TO_ICON;

var CATEGORY_TO_ICON = (_CATEGORY_TO_ICON = {}, (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.BABYEXERCISE, _BabyExercise["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.BALL_GAMES, _BallGames["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.CARDIO, _Cardio["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.CYCLING, _Cycling["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.DANCING, _Dancing["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.GARDENING, _Gardening["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.GOLF, _Golf["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.HORSERIDING, _HorseRiding["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.HOUSEWORK, _HouseWork["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.INTERWALK, _Interwalk["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.OTHER, _Other["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.PILATES, _Pilates["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.PROGRAM, _Program["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.RACQUET, _Racquet["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.REHABILITATION, _Rehabilitation["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.RUNNING, _Running["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.SWIMMING, _Swimming["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.WALKING, _Walking["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.WEIGHTS, _Weights["default"]), (0, _defineProperty2["default"])(_CATEGORY_TO_ICON, _goals.EXERCISE_ACTIVITY_TYPES.YOGA, _Yoga["default"]), _CATEGORY_TO_ICON);
exports.CATEGORY_TO_ICON = CATEGORY_TO_ICON;

var ExerciseIcon = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(ExerciseIcon, _PureComponent);

  var _super = (0, _createSuper2["default"])(ExerciseIcon);

  function ExerciseIcon() {
    (0, _classCallCheck2["default"])(this, ExerciseIcon);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(ExerciseIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          category = _this$props.category,
          className = _this$props.className,
          percentCompleted = _this$props.percentCompleted,
          light = _this$props.light;
      var icon = CATEGORY_TO_ICON[category] || _Other["default"];

      if (percentCompleted === null) {
        return _react["default"].createElement(icon, {
          className: className
        });
      }

      if (percentCompleted < 100) {
        return /*#__PURE__*/_react["default"].createElement(_Donut["default"], {
          size: 75,
          strokeWidth: 5,
          value: percentCompleted,
          progressCircleColor: light ? _colors["default"].lychee[100] : _colors["default"].orange[400]
        }, _react["default"].createElement((0, _styled.progressIcon)(icon, light)));
      }

      return /*#__PURE__*/_react["default"].createElement(_styled.CompletedWrapper, null, /*#__PURE__*/_react["default"].createElement(_styled.MedalIcon, {
        light: light
      }), _react["default"].createElement((0, _styled.completedIcon)(icon, light)));
    }
  }]);
  return ExerciseIcon;
}(_react.PureComponent);

exports.ExerciseIcon = ExerciseIcon;
ExerciseIcon.defaultProps = {
  className: '',
  percentCompleted: null,
  light: false
};
var _default = ExerciseIcon;
exports["default"] = _default;